export enum Period {
    MONTH = 'month',
    QUARTER = 'quarter',
}
